import type {
  StyleBoxSides,
  TextStyleFontFamily,
  TextStyleProperties,
  TextStyleValue,
} from './types';

const fontFamilyToValue = (family?: TextStyleFontFamily): string | undefined => {
  if (family === 'serif') return 'var(--font-serif)';
  if (family === 'sans') return 'var(--font-sans)';
  return undefined;
};

const boxSidesToValue = (sides?: StyleBoxSides): string | undefined => {
  if (!sides) return undefined;
  const { top, right, bottom, left } = sides;
  if ([top, right, bottom, left].every((side) => side == null || side === '')) return undefined;
  return [top, right, bottom, left].map((side) => side || '0').join(' ');
};

const propertiesToVars = (
  prefix: string,
  properties?: TextStyleProperties
): Record<string, string> => {
  if (!properties) return {};
  const vars: Record<string, string> = {};

  if (properties.color) vars[`--ts-${prefix}-color`] = properties.color;
  if (properties.textAlign) vars[`--ts-${prefix}-align`] = properties.textAlign;

  const family = fontFamilyToValue(properties.fontFamily);
  if (family) vars[`--ts-${prefix}-family`] = family;

  if (properties.fontWeight) vars[`--ts-${prefix}-weight`] = properties.fontWeight;
  if (properties.fontSize) vars[`--ts-${prefix}-size`] = properties.fontSize;
  if (properties.lineHeight) vars[`--ts-${prefix}-leading`] = properties.lineHeight;
  if (properties.letterSpacing) vars[`--ts-${prefix}-tracking`] = properties.letterSpacing;

  const margin = boxSidesToValue(properties.margin);
  if (margin) vars[`--ts-${prefix}-margin`] = margin;

  const padding = boxSidesToValue(properties.padding);
  if (padding) vars[`--ts-${prefix}-padding`] = padding;

  return vars;
};

export const textStyleToCssVars = (value?: TextStyleValue): Record<string, string> => ({
  ...propertiesToVars('m', value?.mobile),
  ...propertiesToVars('d', value?.desktop),
});
